"use client";
import SectionTitle from "@/shared/app/ui/text/PageSectionTitle";
import { motion, Variants } from "framer-motion";
import Image from "next/image";

export default function WebusBackgroundSection() {
  const itemVariants: Variants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };
  return (
    <div className="bg-[#2782FF] py-40">
      <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2  md:pt-40 pb-10 pt-5">
        <SectionTitle
          align="left"
          label="Background"
          title={
            <>
              왜 교통약자들은
              <br />
              저상버스를 이용하지 않을까?
            </>
          }
          description={
            <>
              저상버스 도입률은 증가하고 있지만, <br />
              여전히 저조한 교통약자들의 저상버스 이용률
            </>
          }
          colorMode="white"
        />

        <motion.div
          className="mt-14 sm:mt-20 sm:mb-50 mb-20"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          transition={{ staggerChildren: 0.15 }}
        >
          <motion.div
            className="flex flex-col lg:grid lg:grid-cols-2 lg:gap-6 w-full"
            variants={{ visible: { transition: { staggerChildren: 0.25 } } }}
          >
            {/* 왼쪽 그룹 */}
            <motion.div
              className="grid grid-rows-[auto_1fr] gap-6"
              variants={{ visible: { transition: { staggerChildren: 0.2 } } }}
            >
              {/* 첫 번째 행 (1-1, 1-2) */}
              <motion.div
                className="grid grid-cols-1 sm:grid-cols-2 gap-6"
                variants={{
                  visible: { transition: { staggerChildren: 0.15 } },
                }}
              >
                <motion.div
                  className="bg-white h-full rounded-2xl flex justify-center items-center flex-col px-2 py-7 md:py-15 sm:w-auto w-full"
                  variants={itemVariants}
                >
                  <div className="w-14 h-14 md:w-20 md:h-20 relative">
                    <Image
                      src="/assets/images/page/service/webus/clockImage.svg"
                      alt="clock Image"
                      fill
                      className="object-contain object-center"
                    />
                  </div>
                  <p
                    className="text-center mt-5 md:mt-8 text-black-almostBlack text-[15px] leading-5  md:text-lg md:leading-6 tracking-tight"
                    style={{ fontFamily: '"pre-Medium", sans-serif' }}
                  >
                    장애인 콜택시 <br />
                    배차 대기시간{" "}
                    <span
                      className="text-[#2782FF]"
                      style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
                    >
                      평균 50분
                    </span>
                  </p>
                </motion.div>
                <motion.div
                  className="bg-white h-full hidden sm:flex px-2 py-5 rounded-2xl justify-center items-center"
                  variants={itemVariants}
                >
                  <div className="w-24 h-16 relative">
                    <Image
                      src="/assets/images/page/service/webus/symbol.png"
                      alt="clock Image"
                      fill
                      className="object-contain object-center"
                    />
                  </div>
                </motion.div>
              </motion.div>

              {/* 두 번째 행 (2) */}
              <motion.div
                className="bg-white h-full rounded-2xl flex flex-col justify-center items-center py-10 px-5 md:py-10 md:px-10"
                variants={itemVariants}
              >
                <div className="flex flex-row gap-4 justify-between w-full  mb-3 md:mb-4">
                  {/* 왼쪽 말풍선 */}
                  <div className="flex  items-center gap-1 md:gap-3">
                    {/* 아이콘 */}
                    <div className="w-6 h-6 md:w-8 md:h-8 relative flex-shrink-0">
                      <Image
                        src="/assets/images/page/service/webus/happyFace.svg"
                        alt="happy face"
                        fill
                        className="object-contain"
                      />
                    </div>

                    {/* 말풍선 */}
                    <div
                      className="relative bg-[#BAEAFF] text-gray-800 px-3 py-2 rounded-2xl text-[12px] md:text-sm leading-snug

    md:before:content-[''] md:before:absolute md:before:left-[-4px] md:before:top-3
    md:before:w-3 md:before:h-3 md:before:bg-[#BAEAFF] md:before:rotate-45 tracking-tight"
                      style={{
                        fontFamily: '"paperlogy-Medium", sans-serif',
                      }}
                    >
                      저상버스 이용 O
                    </div>
                  </div>

                  {/* 오른쪽 말풍선 */}
                  <div className="flex gap-1 md:gap-3 items-center ">
                    {/* 말풍선 */}

                    <div
                      className="relative bg-[#F0F1F5] text-gray-700 px-3 py-2 rounded-2xl text-[12px] md:text-sm  leading-snug md:before:content-[''] md:before:absolute md:before:right-[-4px] md:before:top-3
    md:before:w-3 md:before:h-3 md:before:bg-[#F0F1F5] md:before:rotate-45 tracking-tight"
                      style={{
                        fontFamily: '"paperlogy-Medium", sans-serif',
                      }}
                    >
                      저상버스 이용 X
                    </div>

                    {/* 아이콘 */}
                    <div className="w-6 h-6 md:w-8 md:h-8 relative flex-shrink-0">
                      <Image
                        src="/assets/images/page/service/webus/sadFace.svg"
                        alt="sad face"
                        fill
                        className="object-contain"
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-[#F0F1F5] w-full flex justify-end px-5 py-2 md:py-3 rounded-full relative tracking-tighter">
                  <p
                    className="text-midGray-30 text-[13px] md:text-base"
                    style={{
                      fontFamily: '"pre-Medium", sans-serif',
                    }}
                  >
                    아니오
                  </p>
                  <div
                    className="bg-[#2F8EFF] text-white absolute left-0 pl-4 top-0 h-full justify-center flex items-center px-3 tracking-tighter rounded-l-full text-[13px] md:text-base"
                    style={{ fontFamily: '"pre-Medium", sans-serif' }}
                  >
                    <p
                      style={{
                        fontFamily: '"pre-Medium", sans-serif',
                      }}
                    >
                      예
                    </p>
                  </div>
                </div>
                <p
                  className="text-center mt-6  md:mt-8 text-black-almostBlack  text-[15px] leading-5 md:text-lg md:leading-7 tracking-tight"
                  style={{ fontFamily: '"pre-Medium", sans-serif' }}
                >
                  장애인 콜택시 배차 대기시간이 1~2시간 이상일 경우, <br />
                  <span
                    className="text-[#2782FF]"
                    style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
                  >
                    저상버스 이용으로 대체
                  </span>
                  하는 경우가 있나요?
                </p>
              </motion.div>
            </motion.div>

            {/* 오른쪽 */}
            <motion.div
              className="bg-white h-full rounded-2xl flex flex-col justify-center items-center py-6 px-6 md:py-12 md:px-12 mt-6 lg:mt-0"
              variants={itemVariants}
            >
              <p
                className="text-left  flex flex-col w-full text-lg  md:text-3xl tracking-tighter leading-7 md:leading-10 text-[#242424]"
                style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
              >
                교통약자 이동편의 계획에 따른 <br />
                <span className="text-[#0075FF]">저상버스 보급 추이</span>
              </p>
              <div className="relative w-full max-w-[500px] aspect-[500/340]">
                <Image
                  src="/assets/images/page/service/webus/table.svg"
                  alt="overview Image"
                  fill
                  className="object-contain object-center"
                />
              </div>
              <p
                className="mt-6 md:mt-10 text-[15px] md:text-lg text-black-almostBlack leading-5 md:leading-7 tracking-tighter "
                style={{ fontFamily: '"pre-Medium", sans-serif' }}
              >
                저상버스 도입률 비교
              </p>
            </motion.div>
          </motion.div>
        </motion.div>
        <SectionTitle
          align="left"
          colorMode="white"
          label="Journey Map"
          title={
            <>
              &ldquo;탈 수 있을까? 내릴 수 있을까?&rdquo;
              <br />
              익숙해지지 않는 저상버스
            </>
          }
          description={
            <>
              단순한 이동이 아닌, 준비부터 탑승까지
              <br />
              교통약자의 입장에서 살펴봅니다.
            </>
          }
        />
        <div className="bg-white w-full md:py-10 md:px-10 py-8 px-4 rounded-3xl mt-10  md:mt-20">
          <div className="relative w-full max-w-[1100px] aspect-[1100/514] md:flex hidden">
            <Image
              src="/assets/images/page/service/webus/journey.svg"
              alt="overview Image"
              fill
              className="object-contain object-center"
            />
          </div>
          <div className="relative w-full max-w-full aspect-[362/812] md:hidden flex">
            <Image
              src="/assets/images/page/service/webus/journey_mobile.png"
              alt="overview Image"
              fill
              className="object-contain object-center"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
